import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA } from '../../constants/onboarding-state/onboarding-constants.ts';

import onboardingStateGetOnboardingStateQuery, {
	type onboardingStateGetOnboardingStateQuery$data,
	type onboardingStateGetOnboardingStateQuery$variables,
} from './__generated__/onboardingStateGetOnboardingStateQuery.graphql.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export const preloadLandUsersInEditorWithRevampedBpqa = (): Promise<{
	data: onboardingStateGetOnboardingStateQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> => {
	return query<
		onboardingStateGetOnboardingStateQuery$data,
		onboardingStateGetOnboardingStateQuery$variables
	>({
		query: onboardingStateGetOnboardingStateQuery,
		variables: {
			key: Object.values(LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA),
		},
	});
};
